export const ORDER = {
	memberPage: 'member-orders-page',
	orderRow: 'order-row',
	paymentRow: 'payment-row',
	adminPage: 'admin-orders-page',
	adminOrderRow: 'admin-order-row',
	adminPaymentRow: 'admin-payment-row',
	ownedBadge: 'course-owned-badge',
};
